
import React from 'react'
import { useState } from 'react'
import RestartAltIcon from '@mui/icons-material/RestartAlt';


export const ResetIcon = ({onClick}) => {

  const [isHovered, setIsHovered] = useState(false); // State to track hover status

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center', // Center vertically
      backgroundColor: 'transparent',
      marginBottom: '10px',
      fontSize: '14px',
      borderRadius:'5%',
    },
    title: {
        fontWeight:'700', 
        fontStyle:'oblique',
        marginLeft: '10px',
    },
    text: {
      paddingLeft: '5px',
      fontWeight:'500',
    
    },
    spacer: {
      width: '10px', // Adjust the width to create empty space
      height:'10px',
     
    },
    button: {
      color:'maroon',
     
      borderRadius:'50%',
      cursor: 'pointer',
     
      display: 'inline-flex', // Ensure the button is inline-flex to align items
      alignItems: 'center', // Center the icon vertically
      
    },
    icon: {
      borderRadius: '50%',
      fontSize: '25px',
     
      backgroundColor: isHovered ? 'lightgrey' : 'inherit',
      
    },
  };

  return (
      <div style={styles.button}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}>
      <RestartAltIcon style={styles.icon} onClick={()=>{onClick()}}/>
      </div>
  )
}

export default ResetIcon;




